export enum ResultMappingIdEnum {
  ID = 'id',
  NAME = 'name',
  URL = 'url',
  URL_PREFIX = 'urlPrefix',
  IMAGE_URL = 'imageUrl',
  IMAGE_URL_PREFIX = 'imageUrlPrefix'
}
